import { apiClient } from "../apiClient";
import { BACKEND_ENDPOINTS } from "../apiEndpoints";

export const getUserProfileApi = (userId) =>
  apiClient.get(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.GET_USER_PROFILE}`,
    { userId },
  );

export const updateUserProfileApi = (profileData) =>
  apiClient.put(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.UPDATE_USER_PROFILE}`,
    profileData,
  );

export const getUserEmailsApi = () =>
  apiClient.get(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.USERS_EMAILS}`,
  );

export const getUnApprovedUsers = (params) =>
  apiClient.get(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.GET_UN_APPROVED_USERS}`,
    { params },
  );

export const approveUserApi = (userId) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.APPROVE_USER}`,
    { userId },
  );
